import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Rotas do fluxo padrão
    {
      //  1
      path: "/verificar-cpf",
      component: () => import("./views/VerificarCpf.vue"),
    },
    {
      // 2
      path: "/selecionar-clinica",
      component: () => import("./views/SelecionarClinica.vue"),
    },
    {
      // 3
      path: "/validar-data-de-nascimento",
      component: () => import("./views/ValidarDataDeNascimento.vue"),
      meta: {
        nomeIndicador: ['INFORME_DATA_NASCIMENTO']
      }
    },
    {
      // 4
      path: "/verificar-dados/titular",
      props: { tipoDeUsuario: "titular" },
      component: () => import("./views/DadosCadastrais/VerificarDados.vue"),
      meta: {
        nomeIndicador: ['CONFERENCIA_DADOS']
      }
    },
    {
      // 4.1
      path: "/atualizar-dados/titular",
      props: { tipoDeUsuario: "titular" },
      component: () => import("./views/DadosCadastrais/AtualizarDados.vue"),
      meta: {
        nomeIndicador: ['ALTERACAO_DADOS']
      }
    },
    {
      // 5
      path: "/selecionar-metodo-de-validacao-da-conta/titular",
      props: { tipoDeUsuario: "titular" },
      component: () => import("./views/Validacao/EscolhaDeMetodo.vue"),
      meta: {
        nomeIndicador: ['ESCOLHA_METODO_CONFIRMACAO']
      }
    },
    {
      // 5.1
      path: "/verificar-codigo-de-validacao-da-conta/titular",
      props: { tipoDeUsuario: "titular" },
      component: () => import("./views/Validacao/ValidarCodigo.vue"),
      meta: {
        nomeIndicador: ['CONFIRMACAO_CONTA']
      }
    },
    {
      // 6
      path: "/cadastrar-senha/titular",
      props: { tipoDeUsuario: "titular" },
      component: () => import("./views/DadosCadastrais/CadastrarSenha.vue"),
      meta: {
        nomeIndicador: ['CRIACAO_SENHA']
      }
    },
    {
      // 7
      path: "/termos-e-condicoes",
      component: () => import("./views/DadosCadastrais/AceiteDosTermos.vue"),
      meta: {
        nomeIndicador: ['TERMOS_DE_USO']
      }
    },

    // Rotas de dependentes
    {
      // 1
      path: "/selecionar-dependente",
      component: () => import("./views/Dependentes/SelecionarDependente.vue"),
      meta: {
        nomeIndicador: ['ESCOLHA_CONTA_DEPENDENTE_ATIVACAO']
      }
    },
    {
      // 2
      path: "/selecionar-modo-de-login-do-dependente/:indiceDependente",
      props: true,
      component: () =>
        import("./views/Dependentes/SelecionarModoDeLoginDependente.vue"),
    },
    {
      // 3A = conta junta; 3B conta separada
      path: "/exibir-dados-do-dependente/:indiceDependente/:contaPropria",
      props: true,
      component: () => import("./views/Dependentes/ExibirDadosDependente.vue"),
      meta: {
        nomeIndicador: ['CONFERENCIA_DADOS_DEPENDENTE', 'CONFERENCIA_DADOS_DEPENDENTE_CONTA_PROPRIA'],
        modificadorDoIndicador: 'contaPropria'
      }
    },
    {
      // 4B 4B 
      path: "/atualizar-dados-do-dependente/:indiceDependente/:contaPropria",
      props: true,
      component: () => import("./views/DadosCadastrais/AtualizarDados.vue"),
      meta: {
        nomeIndicador: ['ALTERACAO_DADOS_DEPENDENTE', 'ALTERACAO_DADOS_DEPENDENTE_CONTA_PROPRIA'],
        modificadorDoIndicador: 'contaPropria'
      }
    },
    {
      // 5B
      path: "/selecionar-metodo-de-validacao-da-conta/:tipoDeUsuario/:indiceDependente",
      props: true,
      component: () => import("./views/Validacao/EscolhaDeMetodo.vue"),
      meta: {
        nomeIndicador: ['ESCOLHA_METODO_CONFIRMACAO_DEPENDENTE_CONTA_PROPRIA']
      }
    },
    {
      // 5.1B
      path: "/verificar-codigo-de-validacao-da-conta/:tipoDeUsuario/:indiceDependente",
      props: true,
      component: () => import("./views/Validacao/ValidarCodigo.vue"),
      meta: {
        nomeIndicador: ['CONFIRMACAO_CONTA_DEPENDENTE']
      }
    },
    {
      // 6B
      path: "/cadastrar-senha/:tipoDeUsuario/:indiceDependente",
      props: true,
      component: () => import("./views/DadosCadastrais/CadastrarSenha.vue"),
      meta: {
        nomeIndicador: ['CRIACAO_SENHA_DEPENDENTE']
      }
    },
    // Fim do fluxo padrão


    // Rotas adjacentes e Etapa dependentes que será alterada
    {
      path: "/suporte",
      component: () => import("./views/Suporte.vue"),
    },
    {
      path: "/suporte/:empresa",
      props: true,
      component: () => import("./views/Suporte.vue"),
    },
    {
      path: "/sucesso",
      component: () => import("./views/Sucesso.vue"),
      props: { titular: false },
      meta: {
        nomeIndicador: ['BOAS_VINDAS']
      }
    },
    {
      path: "/validacao-pendente",
      component: () => import("./views/ValidacaoPendente.vue"),
    },
    {
      path: "/alterar-senha/load/:empresa/:token",
      props: true,
      component: () => import("./views/AlterarSenhaAppLoad.vue"),
    },
    {
      path: "/alterar-senha/load/:token",
      props: true,
      component: () => import("./views/AlterarSenhaAppLoad.vue"),
    },
    {
      path: "/alterar-senha/form",
      props: true,
      component: () => import("./views/AlterarSenhaAppForm.vue"),
    },
    {
      path: "/alterar-senha/form/:empresa",
      props: true,
      component: () => import("./views/AlterarSenhaAppForm.vue"),
    },
    {
      path: "/direcionado/carteira/:carteiraConvenio/:clinicaid",
      props: true,
      component: () => import("./views/AcessoDirecionadoCarteira.vue"),
    },
    {
      path: "/direcionado/:cpf/:clinicaid",
      props: true,
      component: () => import("./views/AcessoDirecionado.vue"),
    },
    {
      path: "/direcionado-clinica/:clinicaid",
      props: true,
      component: () => import("./views/AcessoDirecionadoClinica.vue"),
    },
    {
      path: "/direcionado-clinica/:clinicaid/:empresa",
      props: true,
      component: () => import("./views/AcessoDirecionadoClinica.vue"),
    },
    {
      path: "*",
      redirect: "/verificar-cpf",
    },
    {
      path: "/primeiro-acesso",
      component: () => import("./views/PrimeiroAcesso.vue"),
    },
    // Magic Links, não alterar
    {
      path: "/passo1/:empresa/:referer",
      props: true,
      component: () => import("./views/VerificarCpf.vue"),
    },
    {
      path: "/passo1/:empresa/:referer/:redirectTo",
      props: true,
      component: () => import("./views/VerificarCpf.vue"),
    },
    {
      path: "/passo1/:empresa",
      props: true,
      component: () => import("./views/VerificarCpf.vue"),
    },
  ],
});

export default router;
